import { node } from 'prop-types';
import React from 'react';

export default function FooterBlockLeft({ children }) {
    return (<div
        className={'footer-item-block--left'}>
        {children}
    </div>);
}

FooterBlockLeft.propTypes = {
    children: node,
};